var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:(("color: " + _vm.color))},[_vm._v(_vm._s(_vm.answerText))])}
var staticRenderFns = []

export { render, staticRenderFns }